import { gql } from '@apollo/client';

export const UPDATE_COFFEE_CHAT_ACCEPTANCE = gql`
  mutation UPDATE_COFFEE_CHAT_ACCEPTANCE($roomId: Float!, $isAccepted: Boolean!) {
    updateCoffeeChatAcceptance(roomId: $roomId, isAccepted: $isAccepted) {
      id
      isAccepted
      chatType
    }
  }
`;